exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userAuthHeader[data-v-4100f756]{margin-bottom:12px;font-size:18px;font-weight:700;color:#7d868d}", ""]);

// exports
